import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import localeMixin from '@/locales/mixin.js';
import { mapActions } from 'vuex';
export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      formLogin: {
        username: '',
        password: ''
      } // 表单校验
      ,
      rules: {
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    if (this.$route.query.account && this.$route.query.password) {
      this.loginByAdmin({
        account: this.$route.query.account,
        password: this.$route.query.password
      }).then(function (res) {
        _this.$router.replace(_this.$route.query.redirect || '/index');
      });
      return;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['loginByAdmin'])), {}, {
    submit: function submit() {
      var _this2 = this;
      this.$refs.loginForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  // 登录
                  _this2.loginByAdmin({
                    account: _this2.formLogin.username,
                    password: _this2.formLogin.password
                  }).then(function (res) {
                    console.log('res', res);
                    // 重定向对象不存在则返回顶层路径
                    _this2.$router.replace(_this2.$route.query.redirect || '/index');
                  });
                } else {
                  // 登录表单校验失败
                  _this2.$message.error('信息校验失败，请检查');
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  })
};